module.exports = __webpack_public_path__ + "static/media/pl.562edca5.svg";